import React, { Fragment } from 'react';
import { CardBody, Col } from 'reactstrap';
import { H6 } from '../../../AbstractElements';

const SmallSales1 = () => {
  return (
    <Fragment>
      <Col xs='4' className="p-0">
        <div className="sales-small-chart">
          <CardBody className="p-0 m-auto">
            <H6>1120</H6><span>Phone Sale</span>
          </CardBody>
        </div>
      </Col>
    </Fragment>
  );
};
export default SmallSales1;